export default __webpack_public_path__ + "static/media/amex-colored.1eeb4e64.svg";